import React, { Fragment, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Slider } from "react-burgers";
import { setEnableMobileMenu } from "../../reducers/ThemeOptions";
import UserBox from "layout/AppHeader/Components/UserBox";

const AppMobileMenu = () => {
  const [active, setActive] = useState(false);
  const enableMobileMenu = useSelector((state) => state.ThemeOptions.enableMobileMenu);
  const dispatch = useDispatch();

  /**
   * Toggles the state of the mobile menu by dispatching an action to update
   * the `enableMobileMenu` flag in the Redux store. If `enableMobileMenu` is
   * currently true, it will be set to false, and vice versa.
   * @function
   * @returns {void}
   */
  const toggleMobileSidebar = () => {
    dispatch(setEnableMobileMenu(!enableMobileMenu));
  };

  return (
    <Fragment>
      <div className="app-header__mobile-menu">
        <div onClick={toggleMobileSidebar}>
          <Slider
            width={26}
            lineHeight={2}
            lineSpacing={5}
            color="#6c757d"
            active={active}
            onClick={() => setActive(!active)}
          />
        </div>
      </div>
      <div className="app-header__menu">
        <span>
          <div className="btn-icon btn-icon-only">
            <div className="btn-icon-wrapper">
              <UserBox isMobile={true}/>
            </div>
          </div>
        </span>
      </div>
    </Fragment>
  );
};

export default AppMobileMenu;
